// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retrieveErrorFromServer = (error: any) => {
  if (Array.isArray(Object.values(error.response.data)[0])) {
    return (Object.values(error.response.data)[0] as string[]).join('\n');
  }
  if (error.response.data.detail) {
    return error.response.data.detail;
  }
};
